const sizeData = {
    data() {
        return {

        }
    },
    methods: {
        sizeData(size, current,total) {
            let newSize = 0
            if (size === 10 && total % 10 === 1) newSize = current - 1;
            else if (size === 20 && total % 20 === 1) newSize = current - 1;
            else if (size === 30 && total % 30 === 1) newSize = current - 1;
            else if (size === 40 && total % 40 === 1) newSize = current - 1;
            else newSize = current;
            return newSize
        },
    }
}

export default sizeData